export var SelectPlan;
(function (SelectPlan) {
    function isDomain(plan) {
        return plan.type === "DOMAIN";
    }
    SelectPlan.isDomain = isDomain;
    function isPivot(plan) {
        return (plan.type === "PIVOT_BASIC" || plan.type === "PIVOT_DETAIL");
    }
    SelectPlan.isPivot = isPivot;
    function isRecords(plan) {
        return plan.type === "RECORDS";
    }
    SelectPlan.isRecords = isRecords;
    function isExport(plan) {
        return plan.type === "EXPORT";
    }
    SelectPlan.isExport = isExport;
    let Queries;
    (function (Queries) {
        function getById(plan, id) {
            for (const planQuery of plan.queries) {
                if (planQuery.id === id) {
                    return planQuery;
                }
            }
        }
        Queries.getById = getById;
        function getByName(plan, name) {
            for (const planQuery of plan.queries) {
                if (planQuery.name === name) {
                    return planQuery;
                }
            }
        }
        Queries.getByName = getByName;
    })(Queries = SelectPlan.Queries || (SelectPlan.Queries = {}));
})(SelectPlan || (SelectPlan = {}));
